import Swiper, { Pagination, Navigation } from "swiper";
import "@lottiefiles/lottie-player";
import balanceText from 'balance-text';

export namespace Global {
  //Setup Main Navigation
  let mainNavigation = () => {
    // setup our search
    let searchContainer = document.querySelector(".js-header-search");
    let searchTrigger = document.querySelector(".js-search-trigger");
    let searchClose = document.querySelector(".js-search-close");
    let searchInput = document.querySelector(".search-input") as HTMLInputElement;

    searchTrigger.addEventListener("click", () => {
      searchContainer.classList.toggle("search-expanded");
      searchInput.value = '';
      setTimeout(() => {
        searchInput.focus();
      }, 350);
    });
    searchClose.addEventListener("click", () => {
      searchContainer.classList.toggle("search-expanded");
    });
  };

  let transcriptToggle = () => {
    // setup transcript toggler
    let collapseTrigger = document.querySelector(".js-transcript-trigger");
    let collapseClose = document.querySelector(".js-transcript-close");
    let collapseItem = document.querySelector(".js-transcript-toggle");
    if (!!collapseTrigger || !!collapseClose) {
      collapseTrigger.addEventListener("click", () => {
        collapseItem.classList.toggle("transcript-expanded");
      });
      collapseClose.addEventListener("click", () => {
        collapseItem.classList.toggle("transcript-expanded");
      });
    }
  };

  let initSwiper = () => {
    // init Swiper:
    // setup our initial slide value

    const swiper = new Swiper(".swiper", {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      watchOverflow: true,
      centeredSlides: true,
      watchSlidesProgress: true,
      spaceBetween: 30,
      initialSlide: 1,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          initialSlide: 0,
        },
        // when window width is >= 768px
        768: {
          slidesPerView: 2,
        },
        // when window width is >= 1200px
        1200: {
          slidesPerView: 2,
        },
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    // swiper.init();
  };

  /**
   * Container Initialization
   */
  export const init = () => {
    mainNavigation();
    transcriptToggle();
    initSwiper();
    balanceText();

    // console.log("Code that runs everywhere goes here!");
  };
}

document.addEventListener("DOMContentLoaded", () => {
  Global.init();
});
